module.exports = __webpack_public_path__ + "static/media/level2.524d7961.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/firebag/level2.png
// module id = 1231
// module chunks = 0